"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MATCHING_LIMIT = void 0;
exports.DEFAULT_MATCHING_LIMIT = 20; // Default number of results per page
